import gql from 'graphql-tag'

export const CREATE_SCHEDULER = gql`
  mutation create_scheduler($input: SchedulerInput) {
    create_scheduler(input: $input)
      @rest(type: "Scheduler", path: "/create-scheduler", bodyKey: "input", method: "POST") {
      id
      name
      status
      definition
      next_run_at
      last_updated_by
      entity_ids
      entity_type_ids
      created_at
      updated_at
      result
    }
  }
`
